import usePrivateAxios from '@/common/api/usePrivateAxios'
import { BillingEventData } from '@/common/types/billing/event.type'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseBillingEvent {
  onSuccess?: (response?: AxiosResponse<{ data: BillingEventData }, any>) => void
  onError?: (error: ErrorResponse) => void
}

export const useBillingEvent = ({ onSuccess, onError }: UseBillingEvent) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['billingEvent'],
    mutationFn: (id: string) => {
      return privateAxios.get<{ data: BillingEventData }>(`/billing/events/${id}`)
    },
    onSuccess,
    onError,
  })
}
